import type { InputHTMLAttributes, TextareaHTMLAttributes } from "react";

type CommonProps = {
  label: string;
  hint?: string;
  leadingIcon?: string;
  error?: string | null;
};

type InputProps = CommonProps &
  InputHTMLAttributes<HTMLInputElement> & {
    multiline?: false;
  };

type TextareaProps = CommonProps &
  TextareaHTMLAttributes<HTMLTextAreaElement> & {
    multiline: true;
  };

type AuthFieldProps = InputProps | TextareaProps;

export function AuthField(props: AuthFieldProps) {
  const { label, hint, leadingIcon, error } = props;
  const fieldId =
    props.id ?? props.name ?? label.toLowerCase().replace(/\s+/g, "-");
  const describedBy = error
    ? `${fieldId}-error`
    : hint
      ? `${fieldId}-hint`
      : undefined;

  return (
    <label className="auth-field" htmlFor={fieldId} data-oid="td:ryaq">
      <span className="auth-field__label" data-oid="y.d1f:c">
        {label}
      </span>
      <span className="auth-field__control" data-oid="01by8hv">
        {leadingIcon ? (
          <span
            className="auth-field__icon material-symbols-outlined"
            aria-hidden="true"
            data-oid="j8krapa"
          >
            {leadingIcon}
          </span>
        ) : null}
        {"multiline" in props && props.multiline ? (
          <textarea
            {...(() => {
              const {
                label: _label,
                hint: _hint,
                leadingIcon: _leadingIcon,
                error: _error,
                multiline: _multiline,
                ...rest
              } = props;
              return rest;
            })()}
            id={fieldId}
            aria-label={label}
            aria-invalid={Boolean(error)}
            aria-describedby={describedBy}
            className={`auth-input auth-input--textarea ${error ? "auth-input--error" : ""}`}
            data-oid="6qx_v46"
          />
        ) : (
          <input
            {...(() => {
              const {
                label: _label,
                hint: _hint,
                leadingIcon: _leadingIcon,
                error: _error,
                multiline: _multiline,
                ...rest
              } = props;
              return rest;
            })()}
            id={fieldId}
            aria-label={label}
            aria-invalid={Boolean(error)}
            aria-describedby={describedBy}
            className={`auth-input ${error ? "auth-input--error" : ""}`}
            data-oid="y__0ezj"
          />
        )}
      </span>
      {error ? (
        <span
          className="auth-field__error"
          id={`${fieldId}-error`}
          data-oid="3snsb:s"
        >
          {error}
        </span>
      ) : hint ? (
        <span
          className="auth-field__hint"
          id={`${fieldId}-hint`}
          data-oid="ducfvib"
        >
          {hint}
        </span>
      ) : null}
    </label>
  );
}
